import { render, staticRenderFns } from "./PanelEditMarker.vue?vue&type=template&id=354a5264&scoped=true&"
import script from "./PanelEditMarker.vue?vue&type=script&lang=js&"
export * from "./PanelEditMarker.vue?vue&type=script&lang=js&"
import style0 from "./PanelEditMarker.vue?vue&type=style&index=0&id=354a5264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a5264",
  null
  
)

export default component.exports